<template>
    <div id="app">
        <el-container>
            <el-header>
                <app-menu/>
            </el-header>
            <el-main>
                <router-view class="child-view"/>
            </el-main>
            <el-footer>
                <page-footer/>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import MenuComponent from './components/Menu'
    import PageFooter from './components/PageFooter'
    export default {
        name: 'App',
        components: {
            PageFooter,
            'app-menu': MenuComponent
        }
    }
</script>

<style>
    #app {
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        /*color: #2c3e50;*/
        /*margin-top: 60px;*/
    }

    .el-main {
        min-height: 87vh;
    }

    .el-header {
        margin-bottom: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue